import { SELECTEDUNSUR } from '../../actions/general/index';
export default function (state= '1' ,action){
  switch(action.type){
    case SELECTEDUNSUR:
    return action.payload;
  }
  return state;
}
